import { createContext, useContext } from 'react'

export type ShellContextValue = {
  /** Re-surface the WhatsNew release dialog (trigger lives on More — §5). */
  openWhatsNew: () => void
  /**
   * Hold the CommandDock hidden while a surface with its own composer is
   * mounted (the thread workspace keeps its thread-scoped composer —
   * PR-4's declared delta; unification is PR-14). Returns the release;
   * call it on unmount. Counter-based, so overlapping suppressors are
   * safe.
   */
  suppressDock: () => () => void
}

export const ShellContext = createContext<ShellContextValue | null>(null)

export function useShell(): ShellContextValue {
  const ctx = useContext(ShellContext)
  if (!ctx) throw new Error('useShell must be used inside <AppShell>')
  return ctx
}
